import { useEffect, useState } from 'react';
import {
  NudosButton,
  NudosGenericModal,
  NudosModalContent,
  NudosTextInput
} from '../../../../components/NudosComponents';
import './UploadPaymentLinkModal.scss';
import { IProductList } from '../../../../types/orders';
import errorMessage from '../../../../utils/errorMessage';
import { postPaymentLink } from '../../../../services/orders';
import alertMessage from '../../../../utils/alertMessage';

const UploadPaymentLinkModal = ({
  setShowPaymentLinkModal,
  orderData,
  successfullRequestCallback,
  defaultLink,
  handleTemporalUrl
}: {
  setShowPaymentLinkModal: React.Dispatch<React.SetStateAction<boolean>>;
  orderData: IProductList;
  successfullRequestCallback?: () => void;
  defaultLink?: string;
  handleTemporalUrl?: (url: string) => void;
}) => {
  return (
    <div className="uploadPaymentLinkModal">
      <NudosGenericModal
        modalContent={
          <NudosModalContent
            customWidth="580px"
            customHeight="410px"
            modalContentTitle="Link de pago "
            CustomModalComponent={
              <UploadPaymentLinkCustomModalComponent
                orderData={orderData}
                successfullRequestCallback={successfullRequestCallback}
                setShowPaymentLinkModal={setShowPaymentLinkModal}
                defaultLink={defaultLink}
                handleTemporalUrl={e => {
                  if (handleTemporalUrl) handleTemporalUrl(e);
                }}
              />
            }
            toCloseModal={() => setShowPaymentLinkModal(false)}
          />
        }
      />
    </div>
  );
};

export default UploadPaymentLinkModal;

const UploadPaymentLinkCustomModalComponent = ({
  orderData,
  successfullRequestCallback,
  setShowPaymentLinkModal,
  defaultLink,
  handleTemporalUrl
}: {
  orderData: IProductList;
  successfullRequestCallback?: () => void;
  setShowPaymentLinkModal: React.Dispatch<React.SetStateAction<boolean>>;
  defaultLink?: string;
  handleTemporalUrl?: (url: string) => void;
}) => {
  const { orderId, organizationName } = orderData;
  const [paymentLink, setPaymentLink] = useState<string>();
  const [loading, setLoading] = useState(false);

  const handleUploadPaymentLink = async () => {
    if (!paymentLink || !orderId) return;
    setLoading(true);
    try {
      const body = { paymentLink: paymentLink.trim() };
      await postPaymentLink(orderId, body);
      alertMessage('Se han guardado los cambios');
      setLoading(false);
      successfullRequestCallback && successfullRequestCallback();
      if (handleTemporalUrl) {
        handleTemporalUrl(paymentLink);
      }
      setShowPaymentLinkModal(false);
    } catch (error) {
      errorMessage();
      setLoading(false);
    }
  };

  const isButtonDisabled = loading || !paymentLink;

  useEffect(() => {
    if (!paymentLink && !!defaultLink) setPaymentLink(defaultLink);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLink]);

  return (
    <div className="uploadPaymentLinkCustomModalComponent">
      <h2 className="paymentLinkFormTitle">
        Carga link de pago para orden {orderId} de {organizationName}
      </h2>
      <h3 className="paymentLinkFormSubtitle">
        Revisa el link de pago antes de guardar, recuerda que la empresa recibirá este link a través de un correo{' '}
      </h3>
      <NudosTextInput
        componentSize="large"
        label="Link para tracking del servicio"
        placeholder="Pega el link"
        isFilled={!!paymentLink}
        handleChange={newPaymentLink => setPaymentLink(newPaymentLink)}
        defaultValue={defaultLink}
      />
      <NudosButton
        componentSize="large"
        buttonText="Guardar"
        handleClick={handleUploadPaymentLink}
        isButtonDisabled={isButtonDisabled}
        isButtonLoading={loading}
      />
    </div>
  );
};
